namespace Areas.ContractorPay.Information {
    "use strict";


    export function loadInformationForm(e: any) {
        const form = $("#InformationForm").dxForm("instance");
        const keyId: any = form.option("KeyId");

        if (keyId != null) {           
            let formData = sendRequest(`/ContractorPay/Information/GetContractScheduleValueInfoByContractScheduleValueProfileIdQuery/${keyId}`,
                "",
                "GET");
            form.option("formData", formData);
            Areas.refreshGrid("InformationForm");
        }

    }

    export function updateContractorPayInformation() {
        const form = $("#ContractorPayInformationForm").dxForm("instance");
        const newData: any = form.option("formData");
        const result: any = form.validate();
        const keyId: any = form.option("KeyId");


        if (result.isValid) {
            if (keyId == null || keyId == 0){
                sendRequest(`/ContractorPay/Information/Post/`, JSON.stringify(newData), "POST");
            }
            sendRequest(`/ContractorPay/Information/Put/${keyId}`, JSON.stringify(newData), "PUT");
        }
    }

    export function goToActions(projectInfoId: number, sharePointLink: string) {
        return (e: any) => {
            if (e.value == 1) {
                goToSharePoint(sharePointLink);
                clearSelectBoxSelection(e);
                return;
            }
            if (e.value == 2) {
                goToPIFPAF(projectInfoId);
                clearSelectBoxSelection(e);
                return;
            }
        }
    }

    function goToSharePoint(sharePointLink: string) {
        if (sharePointLink != null) {
            Areas.websiteSharePoint(sharePointLink);
        }
        return
    }

    function goToPIFPAF(projectInfoId: number) {
        let linkInfo = "https://projectinitiation.capnet.ucla.edu/Requests/View/Index/" + projectInfoId + "";
        window.open(linkInfo);
    }
}